import { React, useEffect } from 'react'
import { Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, subDays, parseISO } from 'date-fns'
import { FullScreen, useFullScreenHandle } from 'react-full-screen'
import { MenuExportacao } from '../../../../components/MenuExportacao'
import { useRef, useState } from 'react'

export function GridRegistros(props) {
    const handle = useFullScreenHandle()
    const printRef = useRef()
    const [isFullScreen, setIsFullScrenn] = useState(false)
    const [orderBy, setOrderBy] = useState(null)
    const [ascDesc, setAscDesc] = useState(1)
    const [opStatusRegistros, setOpStatusRegistros] = useState('TODAS')

    function setFullScreen() {
        if (isFullScreen) {
            handle.exit()
            setIsFullScrenn(false)
        } else {
            handle.enter()
            setIsFullScrenn(true)
        }
    }

    const colunas = props.RegistrosBDFiltro?.length > 0
        ? Object.keys(props.RegistrosBDFiltro[0])
        : []

    const handleChangeOpStatusRegistros = (event) => {
        setOpStatusRegistros((event.target).value);
    };

    const [DadosGrid, setDadosGrid] = useState([])

    useEffect(() => {
        const vDadosGrid = opStatusRegistros === 'IMPRESSAS' ?
            props.RegistrosBDFiltro.filter(e => e.Status === 'IMPRESSA')
            :
            opStatusRegistros === 'CANCELADAS' ?
                props.RegistrosBDFiltro.filter(e => e.Status === 'CANCELADA')
                :
                props.RegistrosBDFiltro

        setDadosGrid(vDadosGrid);

    }, [opStatusRegistros, props.RegistrosBDFiltro])


    return (
        <FullScreen handle={handle}>
            <div ref={printRef} className='useExport relative'>
                <MenuExportacao
                    filename={props.Titulo}
                    sheet={props.Titulo}
                    onlyCSV={true}
                    isFullScreen={isFullScreen}
                    setFullScreen={() => setFullScreen()}
                    idTable={`table-to-xls-b2b-${props.Titulo}`}
                />
                <div className={`relative mt-1 mb-8 bg-gray-50 h-full w-full ${isFullScreen && 'p-4'} shadow-lg`}>
                    <h1 className='bg-gradient-to-r rounded-t-md from-slate-900 to-slate-700 text-white-100 font-semibold p-2'>
                        {props.Titulo}
                    </h1>
                    <div className="flex flex-col h-full">
                        <div className={`overflow-auto ${isFullScreen ? '!max-h-[87vh]' : '!max-h-[30vh]'} `}>
                            <table id={`table-to-xls-b2b-${props.Titulo}`} className="border-separate table-fixed w-full">
                                <thead>
                                    <tr className="text-sm sticky top-0 bg-gradient-to-r from-slate-200 to-slate-100">
                                        {colunas.map((col, idx) => (
                                            <th
                                                key={idx}
                                                className="w-[10rem] text-center cursor-pointer"
                                                onClick={() => {
                                                    setOrderBy(col)
                                                    setAscDesc(ascDesc === 0 ? 1 : 0)
                                                }}
                                            >
                                                {col.toUpperCase()}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {DadosGrid?.length > 0 ? (
                                        DadosGrid
                                            .sort((a, b) => {
                                                if (!orderBy) return 0
                                                return a[orderBy] > b[orderBy]
                                                    ? ascDesc === 0 ? 1 : -1
                                                    : ascDesc === 0 ? -1 : 1
                                            })
                                            .map((registro, key) => (
                                                <tr key={key} className="odd:bg-white-100 even:bg-gray-100">
                                                    {colunas.map((col, idx) => {
                                                        let valor = registro[col];

                                                        if ((
                                                            col === 'DtLancamento' || col === 'Vencimento'

                                                        ) && valor) {
                                                            try {
                                                                valor = format(parseISO(valor), 'dd/MM/yyyy');
                                                            } catch (e) {
                                                                valor = registro[col]; // fallback se der erro
                                                            }
                                                        }
                                                        if (typeof valor === 'number' && (
                                                            col === 'CodigoNF' || col === 'CodigoCliente' || col === 'CodigoCompra'
                                                            || col === 'NotaFiscal'
                                                            || col === 'CodigoFornecedor'
                                                            || col === 'CodigoFatura'
                                                            || col === 'Codigo'
                                                        )) {
                                                            try {
                                                                valor = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 0 }).format(valor)
                                                            } catch (e) {
                                                                valor = registro[col]; // fallback se der erro
                                                            }
                                                        }
                                                        else {
                                                            if (typeof valor === 'number') {
                                                                try {
                                                                    valor = Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(valor)
                                                                } catch (e) {
                                                                    valor = registro[col]; // fallback se der erro
                                                                }
                                                            }
                                                        }

                                                        return (
                                                            <td
                                                                key={idx}
                                                                className={`text-sm text-left truncate pr-1 ${typeof valor === 'number' ? 'text-right' : ''}`}
                                                            >
                                                                {valor}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            ))
                                    ) : (
                                        <tr className="text-center">
                                            <td className="p-3 italic" colSpan={colunas.length}>
                                                Sem registros
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-white-100 flex flex-row items-center gap-4 p-2 border-t-2  bg-gradient-to-r from-slate-200 to-slate-100">
                            <p className="text-sm font-bold">
                                Total = {DadosGrid?.length.toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </FullScreen>
    )
}
